export default "__VITE_ASSET__CG5gpIXI__"